module.exports = __webpack_public_path__ + "img/ps-38.09f8c3d8.jpg";